/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Download_Over_Wifi_DescriptionInputs */

const en_mobile_download_over_wifi_description = /** @type {(inputs: Mobile_Download_Over_Wifi_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allow audio download only via Wifi.`)
};

const es_mobile_download_over_wifi_description = /** @type {(inputs: Mobile_Download_Over_Wifi_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permite descargar audio solo por WiFi.`)
};

/**
* | output |
* | --- |
* | "Allow audio download only via Wifi." |
*
* @param {Mobile_Download_Over_Wifi_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_download_over_wifi_description = /** @type {((inputs?: Mobile_Download_Over_Wifi_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Download_Over_Wifi_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_download_over_wifi_description(inputs)
	return en_mobile_download_over_wifi_description(inputs)
});